var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, styled, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getRoofAreaFullInfoById, saveBaseRoofArea } from '../../services/RoofAreaService';
import './../Calculator/calculator.scss';
import { SelectComponent } from '../shared/SelectComponent/SelectComponent';
import { mapContacts, trimString } from './AddNewRoofArea';
import { ButtonComponent } from '../shared/ButtonComponent/ButtonComponent';
import { Loading } from '../shared/Loading/Loading';
import { SnackbarComponent } from '../shared/SnackbarComponent';
import './SavedItems.scss';
import { getContactsListByEmail } from '../../services/ContactService';
import { genrateUuidv4 } from '../../services/ScenarioService';
import { useMsal } from '@azure/msal-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var StyledTextField = styled(TextField)({ '& .MuiInputBase-multiline': { padding: '0px' }, '&.MuiTextField-root': { background: 'white' } });
export var mapContactsByRole = function (roofArea) { var contactClient, contactDesigner, contactContractor; if (roofArea) {
    if (roofArea.R_RoofAreaContacts && roofArea.R_RoofAreaContacts.length > 0) {
        for (var i = 0; i < roofArea.R_RoofAreaContacts.length; i++) {
            switch (roofArea.R_RoofAreaContacts[i].ProjectRoleId) {
                case 1:
                    contactClient = roofArea.R_RoofAreaContacts[i].ContactInfo;
                    break;
                case 2:
                    contactDesigner = roofArea.R_RoofAreaContacts[i].ContactInfo;
                    break;
                case 3:
                    contactContractor = roofArea.R_RoofAreaContacts[i].ContactInfo;
                    break;
                default: break;
            }
        }
    }
} return { contactClient: contactClient, contactDesigner: contactDesigner, contactContractor: contactContractor }; };
export var EditRoofArea = function (_a) {
    var roofAreaId = _a.roofAreaId, projectId = _a.projectId, handleRoofAreaview = _a.handleRoofAreaview, setDeleteRoofDialog = _a.setDeleteRoofDialog;
    var _b = useState(true), errorCheck = _b[0], setErrorCheck = _b[1];
    var _c = useState(''), roofAreaName = _c[0], setRoofAreaName = _c[1];
    var _d = useState(''), buildingName = _d[0], setBuildingName = _d[1];
    var _e = useState(''), roofAreaDescription = _e[0], setRoofAreaDescription = _e[1];
    var _f = useState(false), apiErrorCheck = _f[0], setApiErrorCheck = _f[1];
    var _g = useState(''), client = _g[0], setClient = _g[1];
    var _h = useState(''), observer = _h[0], setObserver = _h[1];
    var _j = useState(''), contractor = _j[0], setContractor = _j[1];
    var _k = React.useState(false), open = _k[0], setOpen = _k[1];
    var _l = useState(), data = _l[0], setData = _l[1];
    var _m = useState(false), loading = _m[0], setLoading = _m[1];
    var _o = useState(), userContacts = _o[0], setUserContacts = _o[1];
    var azureADPCA = useMsal().instance;
    useEffect(function () {
        var _azureADPCA$getActive, _azureADPCA$getActive2;
        var userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com';
        var tokenClaims;
        if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
            var _azureADPCA$getActive3;
            tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
            if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                userEmail = tokenClaims['email'];
            }
        }
        setLoading(true);
        var getRoofAreaById = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _roofArea$, _roofArea$2, _roofArea$3, roofArea, contactResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(roofAreaId > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getRoofAreaFullInfoById(roofAreaId)];
                    case 1:
                        roofArea = _a.sent();
                        setData(roofArea);
                        setBuildingName((_roofArea$ = roofArea[0]) === null || _roofArea$ === void 0 ? void 0 : _roofArea$.BuildingName);
                        setRoofAreaDescription((_roofArea$2 = roofArea[0]) === null || _roofArea$2 === void 0 ? void 0 : _roofArea$2.Description);
                        setRoofAreaName((_roofArea$3 = roofArea[0]) === null || _roofArea$3 === void 0 ? void 0 : _roofArea$3.Name); //if(roofArea[0]?.R_RoofAreaContacts.)
                        contactResult = mapContactsByRole(roofArea[0]);
                        if (contactResult.contactClient)
                            setClient(String(contactResult.contactClient.ContactInfoId));
                        if (contactResult.contactContractor)
                            setContractor(String(contactResult.contactContractor.ContactInfoId));
                        if (contactResult.contactDesigner)
                            setObserver(String(contactResult.contactDesigner.ContactInfoId));
                        _a.label = 2;
                    case 2:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        var fetchContactsByEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
            var contacts, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getContactsListByEmail(userEmail, genrateUuidv4())];
                    case 1:
                        contacts = _a.sent();
                        if (contacts) {
                            result = mapContacts(contacts);
                            setUserContacts(result); // map contacts here
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var timer = setTimeout(function () { getRoofAreaById(); fetchContactsByEmail(); }, 1000);
        return function () { return clearTimeout(timer); };
    }, [roofAreaId, JSON.stringify(data)]);
    var roofAreaData;
    if (data) {
        roofAreaData = data;
    }
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () { var roofAreaToSave, newRoofAreaInfo, result; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                e.preventDefault();
                setApiErrorCheck(false);
                roofAreaToSave = { RoofAreaId: roofAreaId, BuildingName: trimString(buildingName, 50), Description: trimString(roofAreaDescription, 500), ProjectId: projectId, Name: trimString(roofAreaName, 200) };
                if (Number(client) > 0)
                    roofAreaToSave.ClientContactId = Number(client);
                if (Number(contractor) > 0)
                    roofAreaToSave.ContractorContactId = Number(contractor);
                if (Number(observer) > 0)
                    roofAreaToSave.DesignerContactId = Number(observer);
                newRoofAreaInfo = { RoofArea: roofAreaToSave, SaveOperationType: 2 };
                return [4 /*yield*/, saveBaseRoofArea(newRoofAreaInfo)];
            case 1:
                result = _a.sent();
                if (roofAreaToSave.Name && result) {
                    setApiErrorCheck(false);
                    setErrorCheck(false);
                    if (result) {
                        setOpen(true);
                        setTimeout(function () { handleRoofAreaview(roofAreaId, projectId, true); }, 2000);
                    }
                }
                else {
                    if (!result) {
                        setApiErrorCheck(true);
                    }
                    setErrorCheck(true);
                }
                return [2 /*return*/];
        }
    }); }); };
    var onroofAreaNameSelected = function (e) { if (e.target.value) {
        setRoofAreaName(e.target.value);
        setErrorCheck(true);
    }
    else {
        setRoofAreaName('');
        setErrorCheck(false);
    } };
    var handleClose = function (event, reason) { if (event) {
        setOpen(false);
        return;
    } };
    return /*#__PURE__*/ _jsxs(_Fragment, { children: [loading ? /*#__PURE__*/ _jsx("div", { className: "d-flex justify-content-center align-items-center col-12 mt-5", children: /*#__PURE__*/ _jsx(Loading, {}) }) : /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(Box, { className: 'd-flex rn-new-project justify-content-center', children: /*#__PURE__*/ _jsxs(Box, { component: "form", className: "bg-project col-xxl-9 col-xl-9 p-4 mb-3", noValidate: true, children: [/*#__PURE__*/ _jsxs("div", { className: "d-flex justify-content-between", children: [/*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx(Typography, { className: 'headline-3 px-0', children: "Roof Area Details" }) }), /*#__PURE__*/ _jsxs("div", { className: 'd-flex px-0 pb-1 justify-content-end', children: [/*#__PURE__*/ _jsx(ButtonComponent, { isDisabled: !errorCheck, buttonType: "primary", buttonText: "Save", click: onSubmit }), /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: "secondary", buttonText: "Delete", click: function () { return setDeleteRoofDialog(roofAreaId); } })] })] }), /*#__PURE__*/ _jsx("div", { className: "row mx-0", children: /*#__PURE__*/ _jsxs("div", { className: 'justify-content-center row', children: [/*#__PURE__*/ _jsxs("div", { className: 'ml-2 mx-4', children: [/*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsxs(Typography, { className: 'small-para-semibold ', children: ["Roof Area Name: ", /*#__PURE__*/ _jsx("span", { className: "roofnav-error", children: "*" })] }), /*#__PURE__*/ _jsx(StyledTextField, { value: roofAreaName, onChange: onroofAreaNameSelected, id: "roofAreaNameInput", placeholder: "Roof Area Name", size: "small", error: errorCheck && roofAreaName.length == 0, inputProps: { maxLength: 200 } }), errorCheck && roofAreaName.length == 0 && /*#__PURE__*/ _jsx(Typography, { className: 'small-para roofnav-error pt-1', children: "Please submit a value for roof area name" })] }), /*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsx(Typography, { className: 'small-para-semibold ', children: "Building Name/Number:" }), /*#__PURE__*/ _jsx(StyledTextField, { value: buildingName, onChange: function (e) { return setBuildingName(e.target.value); }, id: "buildingNameInput", placeholder: "Bldg 1", size: "small", inputProps: { maxLength: 50 } })] }), /*#__PURE__*/ _jsxs("div", { className: "mt-3", children: [/*#__PURE__*/ _jsx(Typography, { className: 'small-para-semibold ', children: "Roof Area Description:" }), /*#__PURE__*/ _jsx(StyledTextField, { value: roofAreaDescription, onChange: function (e) { return setRoofAreaDescription(e.target.value); }, id: "projectDescriptionInput", placeholder: "Enter description about the project", multiline: true, inputProps: { maxLength: 500 }, rows: 2 })] })] }), /*#__PURE__*/ _jsxs("div", { className: 'ml-2 mx-4', children: [/*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsx(Typography, { className: 'small-para-semibold ', children: "Client/Property Owner" }), /*#__PURE__*/ _jsx(SelectComponent, { id: 'clientSelection', className: "as-2 project-select mr-2", options: userContacts !== null && userContacts !== void 0 ? userContacts : [], setValue: function (value) { return setClient(value); }, value: client })] }), /*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsx(Typography, { className: 'small-para-semibold ', children: "Roof Designer/Observer" }), /*#__PURE__*/ _jsx(SelectComponent, { id: 'observerSelection', className: "as-2 project-select mr-2", options: userContacts !== null && userContacts !== void 0 ? userContacts : [], setValue: function (value) { return setObserver(value); }, value: observer })] }), /*#__PURE__*/ _jsxs("div", { className: "my-3", children: [/*#__PURE__*/ _jsx(Typography, { className: 'small-para-semibold ', children: "Roof Contractor" }), /*#__PURE__*/ _jsx(SelectComponent, { id: 'contractorSelection', className: "as-2 project-select mr-2", options: userContacts !== null && userContacts !== void 0 ? userContacts : [], setValue: function (value) { return setContractor(value); }, value: contractor })] })] })] }) })] }) }) }), /*#__PURE__*/ _jsx(SnackbarComponent, { open: open, handleClose: handleClose, message: 'Roof Area successfully saved' })] });
};
